<template>
  <b-container class="card-container">
    <b-card>
      <template v-slot:header>
        <span class="breadcrumbs"><b-link :to="{name: `${collection}s`}">Video Templates</b-link> / <b-link :to="{name: `${collection}`}">{{item ? item.name : ''}}</b-link> / Edit</span>
        <b-button size="sm" variant="danger float-right" @click="delete_item">Delete</b-button>

        <b-button size='sm' class="float-right mr-2" :to="{name: `${collection}_tune`, params: {from_item: item}}">Tune clone</b-button>

        <b-button v-if="profile.role === 'admin'" size="sm" class="float-right mr-2" :href="`https://console.firebase.google.com/u/0/project/${config && config.firebase_config ? config.firebase_config.projectId : 'puppet-dev'}/firestore/data~2Fproject~2F${$route.params.id}`" target="_blank"><i class="fas fa-database"></i></b-button>
      </template>

      <Loading v-if="item === undefined"/>
      <Error v-else-if="item === null" code="404"></Error>
      <div v-else>

        <b-form @submit.stop.prevent="edit_item">
          <b-alert show variant='warning'>You cannot change the video or variables, please create another project to do this</b-alert>

          <b-alert variant="info" :show="item.status == constants.project_status.pending" class='text-center'>
            <span>Video processing</span>
            <LoadingBar seconds="120" :start_date="item.updated" class='mt-2'/>
          </b-alert>

          <b-form-group invalid-feedback="Must be greater then 4 character">
            <b-form-input v-model="item.name" required placeholder="Enter name" :state="validate_state('name')"></b-form-input>
          </b-form-group>

          <b-form-group>
            <b-form-checkbox v-model="item.quality_control">Enable Quality Control</b-form-checkbox>
          </b-form-group>

          <b-button :href='item.video_url' :download='`vidon_${item.id}.mp4`' variant='secondary' size='sm' class='mb-2 mr-2'><i class="fas fa-download"></i>&nbsp;Video</b-button>
          <b-button :href='item.normalised_video_url' :download='`normalised_vidon_${item.id}.mp4`' variant='secondary' size='sm' class='mb-2 mr-2'><i class="fas fa-download"></i>&nbsp;Normalized Video</b-button>
          <b-button :href='item.fallback_video_url' :download='`fallback_vidon_${item.id}.mp4`' variant='secondary' size='sm' class='mb-2 mr-2'><i class="fas fa-download"></i>&nbsp;Fallback Video</b-button>
          <b-button :href='item.thumbnail_url' :download='`vidon_thumbnail_${item.id}.gif`' variant='secondary' size='sm' class='mb-2'><i class="fas fa-download"></i>&nbsp;Thumbnail</b-button>

          <b-form-group label="Clone:" description="Note you can only select voices which have completed processing" v-if="profile.role === 'admin'">
            <b-form-select v-model="voice_doc" required :options="voice_options"></b-form-select>
          </b-form-group>

          <h4>Call to action</h4>
          <p>Add an call to action to show when the video has completed (leave blank to exclude)</p>
          <b-form-group>
            <b-form-input v-model="item.cta_text" placeholder="Learn more" class='d-inline mr-2' style='max-width: 264px'></b-form-input>
            <b-form-input v-model="item.cta_url" type="url" placeholder="https://example.com"  class='d-inline' style='max-width: 264px'></b-form-input>
          </b-form-group>

          <div v-if="profile.role === 'admin'">
            <b-form-group>
              <b-form-input v-model="item.secondary_cta_text" placeholder="Learn more" class='d-inline mr-2' style='max-width: 264px'></b-form-input>
              <b-form-input v-model="item.secondary_cta_url" type="url" placeholder="https://example.com" class='d-inline' style='max-width: 264px'></b-form-input>
            </b-form-group>
          </div>

          <h4>Cards</h4>
          <Cards :item="item" />

          <!-- TODO add , 'video', 'image' -->

          <!-- <b-form-group description="Face generation technique to use" v-if="profile.role === 'admin'">
            <b-form-select v-model="item.generation_type" :options="['none', 'face']"></b-form-select>
          </b-form-group> -->

          <h4>Transcript</h4>
          <b-card>
            <video :src="item.normalised_video_url" ref="video" width="360" type="video/mpeg"></video>

            <vue-wave-surfer :src="item.normalised_video_url" :options="wavesurfer_options" ref='wavesurfer' class='mb-2'></vue-wave-surfer>

            <b-row>
              <b-col>
                <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                  <b-button-group class="mx-1">
                    <b-button @click="play()" v-if="!playing" key="play" ><i class="fas fa-play" ></i></b-button>
                    <b-button @click="pause()" v-else key="pause"><i class="fas fa-pause" ></i></b-button>
                  </b-button-group>
                  <b-button-group class="mx-1">
                    <b-button @click="zoom(+50)"><i class='fas fa-search-plus' /></b-button>
                    <b-button @click="zoom(-50)"><i class='fas fa-search-minus' /></b-button>
                  </b-button-group>
                  <b-button-group class="mx-1" v-if='edited_regions'>
                    <b-button @click="clear_edits" variant="warning">Reset</b-button>
                  </b-button-group>
                  <b-button-group class="mx-1">
                    <b-button variant="transparent">{{timestamp.toFixed(2)}}</b-button>
                  </b-button-group>
                </b-button-toolbar>
              </b-col>
              <b-col>
                <div v-if="region && region.start">
                  <!-- {{region}} -->
                  <div class='d-inline-block mr-2'>
                    <p>{{region.start.toFixed(2)}}s to {{region.end.toFixed(2)}}s</p>
                  </div>
                  <div class='d-inline-block mr-2'>
                    <b-input v-model='region.data.note' @change="edited_regions = true"></b-input>
                  </div>
                  <div class='d-inline-block'>
                    <b-button @click="delete_region()" variant='danger'>Delete</b-button>
                  </div>

                  <!-- <b-input v-model='region.start'></b-input>
                  <b-input v-model='region.end'></b-input> -->
                </div>
              </b-col>
            </b-row>
          </b-card>

          <Transcript :transcript="item.transcript" :variables="item.variables.map(a => a.word)"/>

          <div v-if="profile.role === 'admin'">
            <h4>Variables</h4>

            <b-table-simple responsive bordered v-if="item.variables && item.variables.length > 0">
              <b-thead head-variant="light">
                <b-tr>
                  <b-th>Variable</b-th>
                  <b-th>Prefix word count</b-th>
                  <b-th>Suffix word count</b-th>
                  <!-- <b-th>Speed</b-th>
                  <b-th>Volume</b-th> -->
                </b-tr>
              </b-thead>
              <b-tr v-for="(variable, index) in item.variables" v-bind:key="index">
                <b-td>{{variable.word}}</b-td>
                <b-td><b-form-input v-model="variable.prefix_words" size="sm" min="0" max="10" type="number"></b-form-input></b-td>
                <b-td><b-form-input v-model="variable.suffix_words" size="sm" min="0" max="10" type="number"></b-form-input></b-td>
                <!-- <b-td><b-form-input v-model="variable.speed" size="sm" min="0" max="2" step=".01" type="number"></b-form-input></b-td>
                <b-td><b-form-input v-model="variable.volume" size="sm" min="0" max="2" step=".01" type="number"></b-form-input></b-td> -->
              </b-tr>
            </b-table-simple>

            <h4>Parts</h4>
            <b-card v-for="(part, index) in item.parts" v-bind:key="index">
              <b-link :href="part.video_url" target='_blank'>Video</b-link>
              <div v-if="part.type === 'variable'">
                <b-table-simple responsive bordered class="mt-2" size="sm">
                  <b-thead head-variant="light">
                    <b-tr>
                      <b-th>Part</b-th>
                      <b-th>Time</b-th>
                      <b-th>Text</b-th>
                      <b-th>Audio</b-th>
                      <b-th>Volume</b-th>
                      <b-th>Speed</b-th>
                      <b-th>Pitch</b-th>
                      <b-th>Enable</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tr v-if='part.group.prefix'>
                    <b-td>Prefix</b-td>
                    <b-td>{{part.group.prefix.start.toFixed(2)}}-{{part.group.prefix.end.toFixed(2)}}</b-td>
                    <b-td>{{part.group.prefix.text}}</b-td>
                    <b-td><Audio :source="part.group.prefix.audio_url" size="sm"/></b-td>
                    <b-td></b-td>
                    <b-td></b-td>
                    <b-td></b-td>
                    <b-td><b-form-checkbox v-model="part.group.prefix.enabled"></b-form-checkbox></b-td>
                  </b-tr>
                  <b-tr v-if='part.group.original'>
                    <b-td>Original</b-td>
                    <b-td>{{part.group.original.start.toFixed(2)}}-{{part.group.original.end.toFixed(2)}}</b-td>
                    <b-td>{{part.group.original.text}}</b-td>
                    <b-td><Audio :source="part.group.original.audio_url" size="sm"/></b-td>
                    <b-td><b-input type='number' min='0' max='3' placeholder="1.0" step="0.1" v-model="part.group.original.volume"/></b-td>
                    <b-td><b-input type='number' min='0' max='3' placeholder="1.0" step="0.1" v-model="part.group.original.speed"/></b-td>
                    <b-td><b-input type='number' min="0.5" max="1.5" step="0.02" placeholder="1.0" v-model="part.group.original.pitch"/></b-td>
                    <b-td><b-form-checkbox v-model="part.group.original.enabled"></b-form-checkbox></b-td>
                  </b-tr>
                  <b-tr v-if='part.group.suffix'>
                    <b-td>Suffix</b-td>
                    <b-td>{{part.group.suffix.start.toFixed(2)}}-{{part.group.suffix.end.toFixed(2)}}</b-td>
                    <b-td>{{part.group.suffix.text}}</b-td>
                    <b-td><Audio :source="part.group.suffix.audio_url" size="sm"/></b-td>
                    <b-td></b-td>
                    <b-td></b-td>
                    <b-td></b-td>
                    <b-td><b-form-checkbox v-model="part.group.suffix.enabled"></b-form-checkbox></b-td>
                  </b-tr>
                </b-table-simple>

                <p><span v-if="part.group.prefix">{{part.group.prefix.text}}</span>&nbsp;<span class='text-danger'>{{part.group.original.text}}</span>&nbsp;<span v-if="part.group.suffix">{{part.group.suffix.text}}</span></p>
              </div>
            </b-card>
          </div>

          <div v-if="profile.role === 'admin'">
            <h4>Video</h4>
            <b-form-group label="Video width">
              <b-form-input v-model="item.video_width" type="number" min="0" max="600" step="10"></b-form-input>
            </b-form-group>

            <h4>Face detection</h4>
            <b-form-group label="Chin ratio">
              <b-form-input v-model="item.face_detect_chin_ratio" type="number" min="0" max="1" step="0.01"></b-form-input>
            </b-form-group>

            <b-form-group label="Nth frame">
              <b-form-input v-model="item.face_detect_nth_frame" type="number" min="0" max="20" step="1"></b-form-input>
            </b-form-group>

            <b-form-group label="Window size">
              <b-form-input v-model="item.face_detect_window_size" type="number" min="0" max="20" step="1"></b-form-input>
            </b-form-group>
          </div>

          <!-- <p>{{item.word_time_offsets}}</p> -->

          <!-- <b-button @click="save_regions">save_regions</b-button> -->

          <LoadingButton type="submit" variant='primary' :loading="is_saving" class='mr-2'>Save</LoadingButton>
          <LoadingButton @click="reprocess" variant='warning' v-if="item.status !== 'pending'">Reprocess</LoadingButton>

          <p class="muted mt-4"><small>Created {{item.created | datetime}}<br>Updated {{item.updated | datetime}}</small></p>
        </b-form>

      </div>
    </b-card>

    <!-- <h4>Evaluation</h4>
    <b-button @click="add_items" variant='warning' class='mb-2'>Add items</b-button>
    <b-card-group>
      <b-card v-for="(item, index) in items" v-bind:key='`item_${index}`' style='min-width: 20em; max-width: 20em;' no-body class='mr-2'>
        <div v-if="item.status === 'complete'">
          <video :src="item.video_url" controls width='100%'/>
        </div>
        <div v-else>
          {{item.status}}
        </div>
        <div class='p-2'>
          <b-badge v-for="(variable, v_index) in item.variables" v-bind:key="`${item.id}_${v_index}`">{{variable.replace_with}}</b-badge>
          <p></p>
        </div>

        <template #footer>
          <b-button :to='{name: "item", params: {id: $route.params.id, item: item.id}}' class='mr-2' size='sm'>Go</b-button>
          <b-button @click="redo(item.id)" variant='warning' size='sm'>Redo</b-button>
          <b-button variant='transparent' size='sm' class='float-right'>{{item.updated | datetime}}</b-button>
        </template>

      </b-card>
    </b-card-group> -->
  </b-container>
</template>

<script>
import { db, storage, FieldValue, config } from '@/main.js'
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"
// import WaveSurferVue from "wavesurfer.js-vue"
import Wavesurfer from "@/components/Wavesurfer.vue"
import Cursor from "wavesurfer.js/dist/plugin/wavesurfer.cursor"
// import Timeline from "wavesurfer.js/dist/plugin/wavesurfer.timeline"
import Regions from "wavesurfer.js/dist/plugin/wavesurfer.regions"
import Audio from "@/components/Audio.vue"
import Transcript from "@/components/Transcript.vue"
import Cards from "@/components/Cards.vue"
import api from "@/lib/api.js"
import moment from 'moment/src/moment'

export default {
  metaInfo: {title: 'Video edit'},
  mixins: [ItemMixin],
  components: {'vue-wave-surfer': Wavesurfer, Audio, Transcript, Cards},
  firestore: function () {
    return {
      item: db.collection(this.collection).doc(this.$route.params.id),
      // items: db.collection(this.collection).doc(this.$route.params.id).collection('item').orderBy('created', 'desc'),
      voices: db.collection('voice').where('status', '==', 'complete').orderBy('created', 'desc')
    }
  },
  validations: {
    item: {
      name: {required, minLength: minLength(3)},
    }
  },
  data() {
    return {
      timestamp: 0,
      voices: [],
      // items: [],
      region: {},
      zoom_level: 150,
      voice_doc: null,
      region_click: false,
      surfer: null,
      collection: 'image_template',
      playing: false,
      edited_regions: false,
      wavesurfer_options: {
        height: 100,
        waveColor: '#D9DCFF',
        progressColor: '#4353FF',
        cursorColor: '#4353FF',
        // barWidth: 1,
        barRadius: 3,
        cursorWidth: 1,
        barGap: 3,
        pixelRatio: 1,
        minPxPerSec: 150,
        scrollParent: true,
        normalize: true,
        splitChannels: false,
        backend: 'MediaElement',
        plugins: [
           Regions.create(),
           Cursor.create()
       ]
      },
    }
  },
  // computed: {
  //   timestamp() {
  //     return this.update_time()
  //   }
  // },
  methods: {
    redo(item_id) {
      db.collection(this.collection).doc(this.$route.params.id).collection('item').doc(item_id).update({updated: new Date(), status: 'pending', quality_control_status: 'pending', quality_control_updated: new Date()})
    },
    async add_items() {
      let names = ['Mary', 'Robert', 'Patricia', 'James', 'Jennifer', 'Michael', 'Linda', 'William', 'Elizabeth', 'David', 'Barbara', 'Richard', 'Susan', 'Joseph', 'Jessica', 'Thomas', 'Sarah', 'Charles', 'Karen', 'Christopher', 'Nancy', 'Daniel', 'Lisa', 'Matthew', 'Margaret', 'Anthony', 'Betty']
      let companies = ['Stripe', 'Airbnb', 'Cruise', 'DoorDash', 'Coinbase', 'Instacart', 'Dropbox', 'Ginkgo Bioworks', 'Gusto', 'Flexport', 'Rappi', 'Brex', 'Reddit', 'Gitlab', 'PagerDuty', 'Checkr', 'Segment', 'Docker', 'Scale', 'Faire', 'Twitch', 'PlanGrid', 'MixPanel', 'Amplitude', 'Optimizely', 'Boom Supersonic', 'Grin', 'Meesho', 'Algolia', 'GOAT', 'Zapier']

      let proms = []
      for (let i=0; i<names.length; i++) {
        let variables = []
        for (let variable of this.item.variables) {
          let replace_with = null
          if (variable['word'] == 'name') {
            replace_with = names[i]
          } else if (variable['word'] == 'company') {
            replace_with = companies[i]
          } else {
            console.warn('Unknown variable', variable)
          }
          variables.push({word: variable['word'], replace_with: replace_with})
        }

        let item_doc = db.collection(this.collection).doc(this.$route.params.id).collection('item').doc()
        let item = {
          updated: new Date(),
          created: new Date(),
          user: db.collection('user').doc(this.item.user.id),
          uid: this.item.user.id,
          team: db.collection('team').doc(this.item.team.id),
          name: moment().format('HH:MM DD/MM/YY'),
          status: 'pending', // TODO
          variables: variables,
          video_url: null,
          error_message: null,
          video_player_url: `https://${config.firebase_config.video_domain}/video/?project=${encodeURIComponent(this.$route.params.id)}&item=${encodeURIComponent(item_doc.id)}`
        }

        console.log(item)
        proms.push(item_doc.set(item))
      }

      await db.collection('project').doc(this.$route.params.id).update({updated: new Date(), items_count: FieldValue.increment(names.length)})
      await Promise.all(proms)
    },
    update_time() {
      if (this.surfer) {
        this.timestamp = this.surfer.getCurrentTime()
      } else {
        this.timestamp = 0
      }
    },
    async reprocess() {
      this.item.status = 'pending'
      await this.edit_item()
    },
    zoom(direction) {
      this.zoom_level += direction
      if (this.zoom_level > 1000) {
        this.zoom_level = 10
      }
      if (this.zoom_level < 0) {
        this.zoom_level = 0
      }

      this.surfer.zoom(Number(this.zoom_level));
    },
    delete_region() {
      let region = this.surfer.regions.list[this.region.id]
      if (region.attributes.backRegion) {
        region.attributes.backRegion.attributes.nextRegion = region.attributes.nextRegion
      }
      if (region.attributes.nextRegion) {
        region.attributes.nextRegion.attributes.backRegion = region.attributes.backRegion
      }

      region.remove()
      this.region = {}
      this.region_click = false
      this.edited_regions = true
    },
    play(seek_time) {
      this.playing = true
      this.surfer.play(seek_time)
      this.region_click = false
    },
    pause() {
      this.playing = false
      this.surfer.pause()
      this.region_click = false
    },
    goto(seek_time) {
      this.play(seek_time)
      this.pause()
      this.region_click = true
    },
    clear_edits() {
      for (let region_id in this.surfer.regions.list) {
        this.surfer.regions.list[region_id].remove()
      }
      this.surfer = null
      this.item.updated = new Date()
      this.edited_regions = false
    },
    async do_before() {
      if ((this.item.cta_text && !this.item.cta_url) || (!this.item.cta_text && this.item.cta_url)) {
        await this.$swal({title: 'Setup call to action', text: "Please add both text and URL if you want a call to action", icon: 'warning'})
        return false
      }

      if ((this.item.secondary_cta_text && !this.item.secondary_cta_url) || (!this.item.secondary_cta_text && this.item.secondary_cta_url)) {
        await this.$swal({title: 'Setup secondary call to action', text: "Please add both text and URL if you want a secondary call to action", icon: 'warning'})
        return false
      }

      let word_time_offsets = this.save_regions()
      this.item.word_time_offsets = word_time_offsets

      for (let variable of this.item.variables) {
        variable['prefix_words'] = Number(variable['prefix_words'])
        variable['suffix_words'] = Number(variable['suffix_words'])
        variable['speed'] = Number(variable['speed']) || 1.0
        variable['volume'] = Number(variable['volume']) || 0.0
      }

      if (this.item.video_width !== undefined && this.item.video_width !== null) this.item.video_width = Number(this.item.video_width || 240)
      if (this.item.face_detect_chin_ratio !== undefined && this.item.face_detect_chin_ratio !== null) this.item.face_detect_chin_ratio = Number(this.item.face_detect_chin_ratio)
      if (this.item.face_detect_nth_frame !== undefined && this.item.face_detect_nth_frame !== null) this.item.face_detect_nth_frame = Number(this.item.face_detect_nth_frame)
      if (this.item.face_detect_window_size !== undefined && this.item.face_detect_window_size !== null) this.item.face_detect_window_size = Number(this.item.face_detect_window_size)

      return true
    },
    save_regions() {
      let word_time_offsets = []
      for (let region_id in this.surfer.regions.list) {
        let region = this.surfer.regions.list[region_id]
        word_time_offsets.push({start: Number(region.start), end:  Number(region.end), word: String(region.data.note)})
      }

      word_time_offsets = word_time_offsets.sort((a, b) => (a.start > b.start) ? 1 : -1)

      return word_time_offsets
    },
    randomColor(alpha) {
      return (
          'rgba(' +
          [
              ~~(Math.random() * 255),
              ~~(Math.random() * 255),
              ~~(Math.random() * 255),
              alpha || 1
          ] +
          ')'
      )
    },
  },
  computed: {
    presentation_description() {
      if (this.item.presentation === 'fullscreen') {
        return 'The video above will be shown'
      } else if (this.item.presentation === 'website') {
        return 'If a url is provided a video of the recipients website is shown with the video above in the bottom left'
      } else {
        return ''
      }
    },
    voice_options() {
      let voice_options = []

      for (let voice of this.voices) {
        if (voice.id) {
          voice_options.push({text: voice.name, value: db.collection('voice').doc(voice.id)})
        }
      }

      return voice_options
    }
  },
  watch: {
    voice_doc(val) {
      if (val && val.id) {
        this.item.voice_doc = db.collection('voice').doc(val.id)
      }
    },
    item: {
      deep: true,
      handler: function(val) {
        if (val && val.voice_doc && val.voice_doc.id && !this.voice_doc) {
          this.voice_doc = db.collection('voice').doc(val.voice_doc.id)
        }

        if (this.$refs.wavesurfer && !this.surfer) {
          this.surfer = this.$refs.wavesurfer.waveSurfer

          var mediaElt = this.$refs.video
          this.surfer.load(mediaElt)

          let previous_region = null
          for (let word of this.item.word_time_offsets) {
            if (word['end'] - word['start'] < 0.1) {
              word['end'] = word['start'] + 0.1
            }
            let region_data = {start: word['start'], end: word['end'], data: {note: word['word']}, color: this.randomColor(0.25)}

            let region = this.surfer.addRegion(region_data)

            if (previous_region) {
              region.attributes.backRegion = previous_region
              previous_region.attributes.nextRegion = region
            }

            previous_region = region
          }

          this.surfer.on('ready', () => {
            this.surfer.enableDragSelection({color: this.randomColor(0.25)}) // randomColor(0.25)
          })

          this.surfer.on('seek', this.update_time)
          this.surfer.on('ready', this.update_time)
          this.surfer.on('audioprocess', this.update_time)

          this.surfer.on('region-click', function(region, e) {
            if (!event.shiftKey) {
              e.stopPropagation()
              region.play()
              this.region_click = true
              this.region = region
            }
          }.bind(this))
          // this.surfer.on('region-click', editAnnotation);
          this.surfer.on('region-in', function(region) {
            if (!this.region_click) {
              this.region = region
            }
          }.bind(this))
          this.surfer.on('region-out', function(region) {
            if (!this.region_click) {
              this.region = {}
            }
          }.bind(this))

          this.surfer.on('region-play', function(region) {
            region.once('out', this.goto.bind(this, region.start))
          }.bind(this));

          this.surfer.on('region-updated', (region) => {
            this.edited_regions = true

            // if(region.end - region.start < 0.1) {
            //   region.end = region.start + 0.1
            // }

            if(region.attributes.nextRegion && region.end > region.attributes.nextRegion.start) {
              region.end = region.attributes.nextRegion.start
            }
            if(region.attributes.backRegion && region.start < region.attributes.backRegion.end) {
              region.start = region.attributes.backRegion.end
            }
          })

          /* Toggle play/pause buttons. */
          this.surfer.on('play', function() {
              this.playing = true
          }.bind(this));
          this.surfer.on('pause', function() {
              this.playing = false
          }.bind(this));
        }
      }
    }
  }
}
</script>

<style>

</style>
